import React from "react";
import { VariantProps } from ".";
import GoogleViewPrice from "../GoogleViewPrice";
import PlusShippingLevels from "../PlusShippingLevels";
import StandardPrice from "../StandardPrice";
import WhyWeDoThis from "./WhyWeDoThis";
const U = ({
  hasWebPlusDiscountedShipping,
  allowWebPlusDiscountedShipping,
  isWebstaurantPlusEligible,
  price,
  minimumBuy,
  mustBuy,
  isGoogleView,
  unitOfMeasure,
  user
}: VariantProps) => {
  return <>
      <div className="map map-override mapU">
        {isGoogleView && !user.registered ? <GoogleViewPrice price={price.price} minimumBuy={minimumBuy} mustBuy={mustBuy} /> : <StandardPrice price={price.price} unitOfMeasure={unitOfMeasure} />}
        <PlusShippingLevels hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping} allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping} isWebstaurantPlusEligible={isWebstaurantPlusEligible} data-sentry-element="PlusShippingLevels" data-sentry-source-file="U.tsx" />
        {!price.hideWhyDoWeDoThis && <WhyWeDoThis type="contact" />}
      </div>
    </>;
};
export default U;